export default "__VITE_ASSET__2RbeZtHG__"